import { call, put, select } from 'redux-saga/effects';
import { Api } from '../../api/api';
import { actions } from '../actions';
import { config } from '../../api/config';
import { errorMessage, downloadFile } from '../../utils';
import { ensureExportFilename } from '../download/download.helpers';

export function* getCouponsSaga({ filter: initialFilter }) {
  try {
    yield put(actions.coupons.setCouponsLoadingAction(true));

    const body = {
      ...initialFilter,
      limit: config.DEFAULTS.recordsPerPage,
    };

    const { coupons, header, footer, count } = yield call(Api.getCoupons, body);

    yield put(actions.coupons.setCouponsAction(coupons, header, footer, count));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.coupons.setCouponsLoadingAction(false));
  }
}

export function* exportCouponsSaga({ filename, body }) {
  try {
    yield put(actions.download.setXlsLoadingAction(true));
    const response = yield call(Api.exportCoupons, body);
    downloadFile(response, filename);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setXlsLoadingAction(false));
  }
}

export function* exportCouponsAsyncSaga({ filter, filename }) {
  try {
    yield put(actions.download.setXlsLoadingAction(true));
    const response = yield call(Api.exportCouponsAsync, filter);
    const exportData = {
      ...response,
      status: response?.status || 'queued',
      filename: response?.filename || ensureExportFilename(filename),
    };

    yield put(actions.download.trackExportAction(exportData));
    yield put(
      actions.coupons.setExportIdentifierAction({
        ...exportData,
        source: 'page',
      })
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setXlsLoadingAction(false));
  }
}

export function* getCouponSaga({ id }) {
  try {
    yield put(actions.coupons.setCouponsLoadingAction(true));

    const coupon = yield call(Api.getCoupon, id);

    yield put(actions.coupons.setCouponAction(coupon));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.coupons.setCouponsLoadingAction(false));
  }
}

export function* exportCouponsCodeByCodeSaga({ couponId, filename }) {
  try {
    yield put(actions.download.setXlsLoadingAction(true));
    const response = yield call(Api.exportCouponsCodeByCodeAsync, couponId);
    const exportData = {
      ...response,
      status: response?.status || 'queued',
      filename: response?.filename || ensureExportFilename(filename),
    };

    yield put(actions.download.trackExportAction(exportData));
    yield put(
      actions.coupons.setExportIdentifierAction({
        ...exportData,
        source: 'details',
      })
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setXlsLoadingAction(false));
  }
}

export function* createCouponSaga({ history, payload }) {
  try {
    yield put(actions.coupons.setCouponsLoadingAction(true));

    const response = yield call(Api.createCoupon, payload);
    yield put(
      actions.coupons.setPendingCouponCreationAction({
        jobId: response.job_id,
        couponId: response.coupon_id,
        expectedCodeAmount: payload.code_amount || 1,
        preview: {
          title:
            payload.title_lt ||
            payload.title_en ||
            payload.title_ru ||
            'Kuponas',
          type: payload.type,
          amount: payload.amount,
          valid_from: payload.valid_from,
          valid_until: payload.valid_until,
        },
      })
    );
    history.push(config.APP_PATHS.coupons);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.coupons.setCouponsLoadingAction(false));
  }
}

export function* updateCouponSaga({ id, history, payload }) {
  try {
    yield put(actions.coupons.setCouponsLoadingAction(true));

    yield call(Api.updateCoupon, id, payload);
    history.push(config.APP_PATHS.coupons);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.coupons.setCouponsLoadingAction(false));
  }
}
